export const nameToInputType = (name, questionarioId) => {
  let qstId = questionarioId || process.env.VUE_APP_QUESTIONARIO_ID;
  if (
    qstId === "default" ||
    qstId === "massei" ||
    qstId === "ferretti" 
  )
    switch (name) {
      case "email":
      case "telefon":
      case "mobile":
      case "name":
      case "surname":
      case "telephone":
      case "piva":
      case "importo_ricevuta":
      case "importo_richiesto":
      case "pec":
      case "codfisc":
      case "idcode":
      case "protocol_pec":
      case "birthplace":
      case "transfer":
      case "experience":
      case "error_flux_code":
      case  "faqhelp_firstname":
      case  "faqhelp_lastname":
      case  "faqhelp_email":
      case  "faqhelp_phone_mobile":
      case  "ragione_sociale":
        return "textInput";
      case "question":
      case "question_amm":
        return "textArea";
      case "data_bonifico":
      case "data_pagamento":
      case "birthday":
        return "date";
      case "contact_times":
      case "pgpf":
      case "legal":
      case "persona":
      case "elenco_registro":
      case "job":
      case "document_type_1":
      case "document_type_2":
          return "select";
      case "area_preferenza":
        return "multiselect";
      case "pec_or_peo_email":
        return "pec_peo_switch"
      case "iban_input":
        return 'iban'
      default:
        null;
    }
};



export const nameToInputPattern = (name, questionarioId) => {
  let qstId = questionarioId || process.env.VUE_APP_QUESTIONARIO_ID;

  if (
    qstId === "default" ||
    qstId === "massei"  ||
    qstId === "ferretti"
  )
    switch (name) {
      case "email":
      case "pec":
        return "[a-zA-Z0-9!#$%&\\-]+(?:\.[a-zA-Z0-9!#$%&\\-]+)*@[a-zA-Z0-9\\-]+(?:\.[a-zA-Z0-9\\-]+)+";

      case "importo_richiesto":
      case "telephone":
      case "telefon":
      case "mobile":
      case "piva":
      case  "faqhelp_phone_mobile":
        return "[0-9]+";
      default:
        null;
    }
};

export const nameToInputLabel = (name,area) => {
  switch (area) {
    case 6:
      if(name === 'mobile' || name === "pec_or_peo_email"){
        return name + '-' + area
      }else{
        return name
      }
    default:
      return name
  }
}
export const nameToContainerInputClassname = (name,area) => {
  let defaultClassname = "input-container col-12 " + name + '-input ' +'area-'+ area
  switch (area) {
    case 6:
      if(name === 'name' || name === 'surname'){
        return 'input-container col-6 ' + name + '-input ' +'area-'+ area
      }
      return defaultClassname
    default:
      return defaultClassname
  }
}
export const nameToErrorKeyLabel = (name,area) => {
  switch (area) {
    case 6:
      if(name === 'name' || name === 'surname' || name === 'ragione_sociale'){
        return name + '-field-not-ok-' + area
      }else{
        return name + '-field-not-ok'
      }
    default:
      return name + '-field-not-ok'
  }
}
export const nameToInputTextMaxLength = (name) => {
  switch (name) {
    case "piva":
      return "12"
    case "codfisc":
      return "16"
    case "idCode":
      return "8"
    case "birthplace":
      return "25"
    default:
      return "80"
  }
}

export const nameToDateModelType = (name) => {
  switch (name) {
    default:
      return "yyyy-MM-dd"
  }
}

export const nameToLinkedToOtherInput = (name,area) => {
  switch (name) {
    case "codfisc":
    case "piva":
    case "name":
    case "surname":
    case "ragione_sociale":
      if(area === 6){
        return true
      }else{
        return false
      }
    case "telefon":
    case "mobile":
      if(area !== 6){
        return true
      }else{
        return false
      }
    default:
      return false
  }
}

export const nameToInputTextType = (name) => {
  switch (name) {
    //case "piva":
    case "telefon":
    case "telephone":
    case "mobile":
      return "text"
    case "email":
    case "pec":
      return "email"
    default:
      return "text"
  }
}

export const nameToSelectOptions = (name) => {
  switch (name) {
    case "contact_times":
      return [
        { value: '', text: "Seleziona" , selected: 'selected'},
        { value: "Dalle 09:00 alle 12:00", text: "Dalle 9:00 alle 12:00" },
        { value: "Dalle 15:00 alle 18:00", text: "Dalle 15:00 alle 18:00" },
      ];
    case "pgpf":
      return [
        { value: '', text: "Seleziona", selected: true },
        { value: "Persona Fisica", text: "Persona Fisica" },
        { value: "Persona Giuridica", text: "Persona Giuridica" },
      ];
    case "legal":
      return [
        { value: '', text: "Seleziona" , selected: true},
        { value: "Yes", text: "Si" },
        { value: "No", text: "No" },
      ];
    case "persona":
      return [
        { value: '', text: "Seleziona" , selected: true},
        { value: "Persona Fisica", text: "Persona Fisica" },
        { value: "Persona Giuridica", text: "Persona Giuridica" },
      ];
    case "elenco_registro":
      return [
        { value: '', text: "Seleziona", selected: true },
        { value: "ElencoAgentieMediatori", text: "Elenco Agenti e Mediatori" },
        { value: "RegistroCambiavalute", text: "Registro Compro Oro" },
        {
          value: "RegistroOperatoriCriptoValute",
          text: "Registro Operatori Cripto Valute",
        },
      ];
    case "job":
      return [
        { value: '', text: "Seleziona", selected: true },
        {
          value:
            "Associazione di categoria Iscritti negli Elenchi e/o Registri OAM",
          text: "Associazione di categoria Iscritti negli Elenchi e/o Registri OAM",
        },
        {
          value: "Intermediario finanziario e bancario Istituto di pagamento",
          text: "Intermediario finanziario e bancario Istituto di pagamento",
        },
        {
          value:
            "Istituto di moneta elettronica Professionista, che formula la domanda in nome e per conto di un operatore iscritto in uno degli Elenchi e/o Registri OAM",
          text: "Istituto di moneta elettronica Professionista, che formula la domanda in nome e per conto di un operatore iscritto in uno degli Elenchi e/o Registri OAM",
        },
        {
          value: "Non appartengo a nessuna tra le precedenti categorie",
          text: "Non appartengo a nessuna tra le precedenti categorie",
        },
      ];
    case "document_type_1":
      return [
        { value: '', text: "Seleziona", selected: true },
        { value: "Tipo documento 2", text: "Tipo documento 2" },
      ];
    case "document_type_2":
      return [
        { value: '', text: "Seleziona" , selected: true},
        { value: "Cartadiidentita", text: "Carta di identita" },
        { value: "Patentediguida", text: "Patente di guida" },
        { value: "Passaporto", text: "Passaporto" },
      ];
    case "area_preferenza":
      return [
        { value: "Ufficio Affari Legali", text: "Ufficio Affari Legali" },
        { value: "Ufficio IT e Privacy", text: "Ufficio IT e Privacy" },
        { value: "Ufficio Vigilanza", text: "Ufficio Vigilanza" },
        { value: "Ufficio Amministrazione, Finanza e Controllo", text: "Ufficio Amministrazione, Finanza e Controllo" },
        { value: "Ufficio Elenchi", text: "Ufficio Elenchi" },
        { value: "Ufficio del Personale e Segreteria Generale", text: "Ufficio del Personale e Segreteria Generale" },
        { value: "Ufficio Centro Studi", text: "Ufficio Centro Studi" },
      ];
    default:
      return [];
  }
};
